import ServiceEndpoints from "../ServiceEndpoints";
import {RequestsWithMetrics} from "../../model/RequestsWithMetrics";
import {RequestFilterOptionsDto} from "../../model/RequestFilterOptions";
import {ActiveMetrics} from "../../model/ActiveMetrics";
import {TabMetrics} from "../../model/TabMetrics";

export async function fetchActiveMetrics(userToken?: string): Promise<ActiveMetrics> {
    return await fetch(ServiceEndpoints.FetchActiveMetrics,
        {
            method: 'get',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken}
        })
        .then( async (resp) => {
            if (resp.ok) {
                return await resp.json() as ActiveMetrics;
            } else {
                return new ActiveMetrics();
            }
        })
        .catch((error) => {
            console.error(error);
            return new ActiveMetrics();
        });
}

export async function fetchTabMetrics(tabMetricsForm: any, signal: AbortSignal, userToken?: string): Promise<TabMetrics> {
    return await fetch(ServiceEndpoints.FetchTabMetrics,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(tabMetricsForm),
            signal: signal
        })
        .then( async (resp) => {
            if (resp.ok) {
                return await resp.json() as TabMetrics;
            } else {
                return new TabMetrics();
            }
        })
        .catch((error) => {
            if (signal.aborted) {
                console.log('Fetch aborted');
            } else {
                console.error(error);
            }
            return new TabMetrics();
        });
}

export async function fetchActiveRequests(activeRequestsForm: any, userToken: string | undefined, signal: AbortSignal): Promise<RequestsWithMetrics> {
    return await fetch(ServiceEndpoints.FetchActiveRequests,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(activeRequestsForm),
            signal: signal
        })
        .then( async (resp) => {
            if (resp.ok) {
                return await resp.json() as RequestsWithMetrics;
            } else {
                return new RequestsWithMetrics();
            }
        })
        .catch((error) => {
            if (!signal.aborted) {
                console.error(error);
            }
            return new RequestsWithMetrics();
        });
}

export async function excelExportActive(activeRequestsForm: any, filename: string, userToken?: string): Promise<boolean> {
    return await fetch(ServiceEndpoints.ExportToExcelActiveRequests,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(activeRequestsForm)
        })
        .then((resp) => {
            if(resp.ok) {
                return resp;
            }
            return undefined;
        })
        .then((response) => {
            if(response) {
               return response.blob();
            }
            return undefined;
        })
        .then((blob) => {
            if(blob) {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename + '.xlsx');
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.remove();
                return true;
            }
            return false;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
}

export async function fetchRequestFilterOptions(userToken?: string): Promise<RequestFilterOptionsDto | undefined> {
    return await fetch(ServiceEndpoints.FetchRequestFilterOptions,
        {
            method: 'get',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken}
        })
        .then(async (resp) => {
            if (resp.ok) {
                return await resp.json() as RequestFilterOptionsDto;
            }
            return undefined;
        }).catch((error) => {
            console.error(error);
            return undefined;
        });
}